import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Chip from 'eventtia-ui-components/lib/Chip';
import StarIcon from '@material-ui/icons/Star';
import DenyIcon from '@material-ui/icons/HighlightOff';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import IconButton from '@material-ui/core/IconButton';
import RecommendationIcon from '@material-ui/icons/NewReleases';
import { fade } from '@material-ui/core/styles/colorManipulator';
import { connect } from 'react-redux';
import clsx from 'clsx';
import useStringTransforms from '../../hooks/useStringTransforms';
import CustomPropTypes from '../../helpers/CustomPropTypes';
// import ChatButton from './ChatButton';
import EmailIcon from '../../assets/Email';
import TelephoneIcon from '../../assets/Telephone';
import LinkedInIcon from '../../assets/LinkedIn';
import { parseFieldsByInternalId } from '../../helpers/customFields';
import { INTERNAL_IDS } from '../../helpers/constants';

const useStyles = makeStyles((theme) => ({
  personCard: {
    // width: 350,
    // height: 140,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'transparent',
    border: 'none',
    minWidth: 0,
    // marginBottom: theme.spacing(5),
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
      // padding: theme.spacing(2, 0, 1, 2),
      alignItems: 'stretch',
    },
  },
  fullWidth: {
    width: '100%',
  },
  avatarWrapper: {
    position: 'relative',
    width: '100%',
    // paddingTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      paddingTop: 0,
      flexDirection: 'row',
      // paddingBottom: theme.spacing(1.25),
    },
  },
  avatar: {
    height: 140,
    width: 140,
    backgroundColor: theme.palette.lightGrey.main,
    color: theme.palette.primary.main,
    // borderRadius: 15,
    [theme.breakpoints.down('sm')]: {
      height: 140,
      width: 140,
    },
  },
  filterAvatar: {
    filter: 'grayscale(100%)',

  },
  name: {
    fontSize: 15,
    fontFamily: 'Brilliant Cut Pro',
    lineHeight: '100%',
    letterSpacing: '0.04em',
    marginBottom: theme.spacing(0.2),
    textAlign: 'start',
    fontWeight: 700,
    color: '#000000',
    // overflow: 'hidden',
    // whiteSpace: 'nowrap',
    // textOverflow: 'ellipsis',
    [theme.breakpoints.down('md')]: {
      fontSize: 13,
    },
  },
  role: {
    fontSize: 12,
    fontFamily: 'Brilliant Cut Pro',
    lineHeight: '14.4px',
    fontWeight: 600,
    textTransform: 'uppercase',
    // overflow: 'hidden',
    // whiteSpace: 'nowrap',
    // textOverflow: 'ellipsis',
    textAlign: 'start',
    margin: theme.spacing(1, 0),
  },
  headline: {
    fontSize: 11,
    fontFamily: 'Brilliant Cut Pro',
    lineHeight: '16px',
    fontWeight: 'bold',
    // overflow: 'hidden',
    // whiteSpace: 'nowrap',
    // textOverflow: 'ellipsis',
    textAlign: 'start',
    textTransform: 'uppercase',
    color: theme.palette.primary.main,
  },
  email: {
    fontSize: 12,
    lineHeight: '14.4px',
    // fontFamily: 'Baskerville Old',
    color: theme.palette.darkGrey.dark,
    textAlign: 'start',
    textDecoration: 'none',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      overflowWrap: 'anywhere',
      wordBreak: 'break-word',
    },
  },
  telephone: {
    fontSize: 12,
    lineHeight: '14.4px',
    // fontFamily: 'Baskerville Old',
    color: theme.palette.darkGrey.dark,
    textAlign: 'start',
    textDecoration: 'none',
  },
  description: {
    paddingLeft: theme.spacing(2.25),
    width: 'inherit',
    height: '150px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    // overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0, 1, 0, 2),
    },
  },
  phoneNumber: {
    fontFamily: 'Avenir Next',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '14px',
    textAlign: 'start',
  },
  position: {
    fontFamily: 'Avenir Next',
    fontWeight: '500',
    fontSize: 12,
    textAlign: 'start',
    lineHeight: '100%',
    letterSpacing: '0.04em',
    color: theme.palette.darkGrey.main,
  },
  region: {
    fontFamily: 'Avenir Next',
    fontWeight: '500',
    fontSize: 12,
    textAlign: 'start',
    lineHeight: '100%',
    letterSpacing: '0.04em',
    color: theme.palette.secondary.main,
    textTransform: 'uppercase',
  },
  descriptionSpacer: {
    minHeight: 12,
  },
  headlineContainer: {
    height: '40%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  noRegion: {
    fontFamily: 'Avenir Next',
    fontWeight: '500',
    fontSize: 10,
    textAlign: 'start',
    lineHeight: '100%',
    letterSpacing: '0.04em',
    color: theme.palette.secondary.main,
    marginTop: theme.spacing(0.5),
    // marginBottom: theme.spacing(4.75),
  },
  marketDepartment: {
    fontFamily: 'Baskerville Old',
    fontWeight: '400',
    fontSize: 12,
    textAlign: 'start',
    lineHeight: '14px',
    letterSpacing: '0.04em',
    color: 'black',
  },
  detail: {
    textAlign: 'start',
    fontSize: 12,
    color: theme.palette.darkGrey.light,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  infoChip: {
    flexDirection: 'row',
    backgroundColor: theme.palette.lightGrey.main,
    boxShadow: '0px 1px 2px #0000001F',
    color: theme.palette.primary.main,
    fontSize: 12,
    fontWeight: 'bold',
    position: 'absolute',
    display: 'flex',
    top: 4,
    left: 20,
    width: 'auto',
    height: 20,
    '& > svg': {
      color: theme.palette.primary.main,
      width: 14,
      height: 14,
    },
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      top: 0,
      left: 0,
      marginLeft: 'auto',
      marginRight: theme.spacing(2),
      marginBottom: theme.spacing(),
    },
  },
  deniedChip: {
    left: 0,
  },
  recommendation: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  attendanceModeChip: {
    fontSize: 12,
    width: 84,
    height: 20,
    marginBottom: theme.spacing(),
    backgroundColor: fade(theme.palette.primary.main, 0.05),
    color: theme.palette.primary.main,
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(8.75),
    },
  },
  fieldAttendanceMode: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  contactInfoContainer: {
    marginTop: theme.spacing(-1),
    marginBottom: theme.spacing(-1),
    display: 'flex',
    gap: theme.spacing(3),
  },
  contactIcon: {
    padding: theme.spacing(1),
    marginLeft: theme.spacing(-1),
    color: theme.palette.primary.main,
  },
  phoneText: {
    color: theme.palette.secondary.main,
    textDecoration: 'none',
    marginLeft: theme.spacing(),
  },
}));

const PersonCard = ({
  person,
  type,
  showContactInfo,
  showPhone,
  fullWidth,
  showChatButton,
  attendeeTypeCustomFields,
  hideZone,
}) => {
  const classes = useStyles();
  const { t } = useTranslation('attendees', 'global');
  const { toTitleCase } = useStringTransforms();
  const {
    firstName,
    lastName,
    usedNameIfDifferent,
    fullName,
    position,
    headshot,
    picture,
    rating,
    denied,
    recommended,
    // telephone,
    company,
    email,
    fields,
  } = person;
  const fieldsId = parseFieldsByInternalId(fields, attendeeTypeCustomFields);
  // const country = fields[fieldsId[INTERNAL_IDS.nationality]];
  const zoneDetail = fields[fieldsId[INTERNAL_IDS.zonesDetails]];
  const telephone = fields[fieldsId[INTERNAL_IDS.needHelpPhone]];
  const role = fields[fieldsId[INTERNAL_IDS.role]]; // TODO?
  const linkedInLink = fields[fieldsId[INTERNAL_IDS.linkedInProfile]];
  const normalizedLinkedInLink = linkedInLink?.startsWith('http')
    ? linkedInLink
    : `https://${linkedInLink}`;

  // const headline = fields[fieldsId[INTERNAL_IDS.headline]];
  const attendeeImage = (
    type === 'attendee' ? (headshot?.filename && headshot.medium) : (picture?.filename && picture.large)
  );

  const hasContactInfo = (
    (showPhone && telephone)
    || (showContactInfo && (email || linkedInLink))
    || showChatButton
  );

  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div
      className={clsx(classes.personCard, fullWidth && classes.fullWidth)}
    >
      <div className={classes.avatarWrapper}>
        <Avatar
          src={attendeeImage}
          variant="square"
          className={clsx(classes.avatar, attendeeImage && classes.filterAvatar)}
        />
        {!!rating && !mobile && (
          <Chip
            className={classes.infoChip}
            label={rating.toString()}
            icon={<StarIcon />}
            size="small"
          />
        )}
        {!!denied && !mobile && (
          <Chip
            className={clsx(classes.infoChip, classes.deniedChip)}
            label={t('actions.denyParticipant')}
            icon={<DenyIcon />}
            size="small"
          />
        )}
        {recommended && (
          <RecommendationIcon
            color="primary"
            className={classes.recommendation}
          />
        )}

        <div className={classes.description}>
          {type === 'attendee' ? (
            <div>
              {usedNameIfDifferent ? (
                <Typography className={classes.name} variant="subtitle2">
                  {toTitleCase(usedNameIfDifferent)}
                </Typography>
              ) : (
                <>
                  <Typography className={classes.name} variant="subtitle2">
                    {firstName ? toTitleCase(firstName) : <br />}
                  </Typography>
                  <Typography className={classes.name} variant="subtitle2">
                    {lastName ? toTitleCase(lastName) : <br />}
                  </Typography>
                </>
              )}
              <Typography className={classes.role} variant="subtitle2">
                {role}
              </Typography>
            </div>
          ) : (
            <div>
              <Typography className={classes.name} variant="subtitle2">
                {toTitleCase(fullName)}
              </Typography>
              <Typography className={classes.role} variant="subtitle2">
                {role}
              </Typography>
            </div>
          )}
          <div className={classes.headlineContainer}>
            <Typography className={classes.headline} variant="subtitle2">
              {(position && company) ? `${position}, ${company}` : (company)}
            </Typography>
            {/* {company && (
            <Typography className={classes.headline} variant="subtitle2">
                {toTitleCase(company)}
            </Typography>
            )} */}
            {/* {position && (
              <Typography className={classes.headline} variant="subtitle2">
                {position && toTitleCase(position, true).toUpperCase()}
              </Typography>
            )} */}
            {/* {email && (
            <div>
              <Typography className={classes.email} variant="body2">
                {email}
              </Typography>
            </div>
            )} */}
            {hasContactInfo && (
            <div className={classes.contactInfoContainer}>
              {(showPhone && telephone) && (
                <div className={classes.phoneContainer}>
                  <IconButton
                    component="a"
                    href={`tel:${telephone}`}
                    rel="noopener noreferrer"
                    color="secondary"
                    className={classes.contactIcon}
                  >
                    <TelephoneIcon />
                  </IconButton>
                  <a
                    className={classes.phoneText}
                    href={`tel:${telephone}`}
                    rel="noopener noreferrer"
                  >
                    {telephone}
                  </a>
                </div>
              )}
              {/* {showChatButton && (
                <ChatButton person={person} />
              )} */}
              {(showContactInfo && email) && (
                <IconButton
                  component="a"
                  href={`mailto:${email}`}
                  rel="noopener noreferrer"
                  target="_blank"
                  color="secondary"
                  className={classes.contactIcon}
                >
                  <EmailIcon />
                </IconButton>
              )}
              {(showContactInfo && linkedInLink) && (
                <IconButton
                  component="a"
                  href={normalizedLinkedInLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  color="secondary"
                  className={classes.contactIcon}
                >
                  <LinkedInIcon />
                </IconButton>
              )}
            </div>
            )}
          </div>
          {/* {telephone && (
            <Typography className={classes.phoneNumber} variant="body2">
              {toTitleCase(telephone, true)}
            </Typography>
          )} */}
          {/* {position && (
            <div>
              <Typography className={classes.position} variant="body2">
                {toTitleCase(position, true).toUpperCase()}
              </Typography>
              {!country && (
                <Typography className={classes.noRegion} variant="body2">
                  Region
                </Typography>
              )}
            </div>
          )} */}
          {(!!zoneDetail && !hideZone) && (
            <div>
              <Typography className={classes.region} variant="body2">
                {toTitleCase(zoneDetail, true).toUpperCase()}
              </Typography>
            </div>
          )}
          {((!zoneDetail || hideZone) && !hasContactInfo) && (
            <div className={classes.descriptionSpacer} />
          )}

        </div>
        {/* {company && (
          <div>
            <Typography className={classes.marketDepartment} variant="body2">
              {toTitleCase(company)}
            </Typography>
          </div>
        )} */}
      </div>
    </div>
  );
};

PersonCard.propTypes = {
  person: PropTypes.shape({
    id: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    usedNameIfDifferent: PropTypes.string,
    fullName: PropTypes.string,
    company: PropTypes.string,
    telephone: PropTypes.string,
    attendanceMode: PropTypes.string,
    headshot: PropTypes.shape({
      filename: PropTypes.string,
      medium: PropTypes.string,
    }),
    picture: PropTypes.shape({
      filename: PropTypes.string,
      large: PropTypes.string,
    }),
    fields: PropTypes.object,
    position: PropTypes.string,
    attendeeTypeName: PropTypes.string,
    rating: PropTypes.number,
    denied: PropTypes.bool,
    recommended: CustomPropTypes.recommendation,
    email: PropTypes.string,
  }).isRequired,
  type: PropTypes.string,
  showContactInfo: PropTypes.bool,
  showPhone: PropTypes.bool,
  fullWidth: PropTypes.bool,
  hideZone: PropTypes.bool,
  showChatButton: PropTypes.bool,
  attendeeTypeCustomFields: PropTypes.objectOf(
    CustomPropTypes.attendeeTypeCustomField
  ),
};

PersonCard.defaultProps = {
  type: 'attendee',
  showContactInfo: false,
  showPhone: false,
  fullWidth: false,
  hideZone: false,
  showChatButton: false,
  attendeeTypeCustomFields: {},
};

const mapStateToProps = ({
  entities: {
    events,
    attendeeTypeCustomFields,
  },
}) => ({
  events, attendeeTypeCustomFields,
});

export default connect(mapStateToProps)(PersonCard);
